import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export const VARIANTS = {
    ALT: 'alt',
    PRIMARY: 'primary'
};

/**  Configurable Button component with preset styles */
const Button = props => {
    const {
        as: Component,
        children,
        className,
        disabled,
        variant,
        ...otherProps
    } = props;

    return (
        <Component
            className={cx(
                'es-btn',
                variant && `es-btn--${variant}`,
                disabled && 'es-btn--disabled',
                className
            )}
            disabled={disabled}
            {...otherProps}
        >
            <span className="es-btn__label">{children}</span>
        </Component>
    );
};

Button.displayName = 'Button';

Button.propTypes = {
    /** Specifies the root component. Can be an HTML element or React component. */
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    /** Style preset options */
    variant: PropTypes.oneOf(Object.values(VARIANTS))
};

Button.defaultProps = {
    as: 'button',
    variant: VARIANTS.PRIMARY
};

export default Button;
